module.exports = __webpack_public_path__ + "static/media/unstoppable-domains-logo-light.5c5ccaa3.svg";